import Icon from '../components/Icon.vue'

Icon.register({
  running: {
    width: 416,
    height: 512,
    paths: [
      {
        d: 'M272 96C298.5 96 320 74.5 320 48S298.5 0 272 0 224 21.5 224 48 245.5 96 272 96zM113.7 317.5L98.9 352H32C14.3 352 0 366.3 0 384S14.3 416 32 416H109.5C128.7 416 146 404.6 153.6 386.9L162.3 366.4 151.7 360.1C134.4 349.9 121.6 334.7 113.7 317.5zM384 224H340L313.9 170.7C301.4 145.2 278.5 126.5 252.1 119.8L181.1 98.7C152.8 91.9 123.3 98.1 100.2 115.8L60.5 146.2C46.5 157 43.9 177 54.6 191.1S85.5 207.7 99.5 197L139.2 166.6C146.8 160.7 156.6 158.6 164.4 160.4L179.1 164.8 141.7 252.2C129.1 281.7 140.4 316.2 168 332.5L253 382.7 225.5 470.4C220.2 487.3 229.6 505.2 246.5 510.5 249.7 511.5 252.9 512 256 512 269.7 512 282.3 503.2 286.6 489.5L318.2 388.5C324.1 367.7 315.3 345.4 296.6 334.1L235.3 297.9 266.6 219.7 286.9 261.1C294.9 277.4 311.8 288 330 288H384C401.7 288 416 273.6 416 256S401.7 224 384 224z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/running.js
// module id = NBBQ
// module chunks = 144